// extracted by mini-css-extract-plugin
var _1 = "OIS6aD4zffUqvQmwXn5u";
export { _1 as "search" }
